export class AccountingBalanceSheetEquityAndLiabilitiesModel {

  patrimonio_Neto: number;
  fondos_Propios: number;
  capital: number;
  capital_Escriturado: number;
  capital_No_Exigido: number;
  prima_De_Emision: number;
  reservas: number;
  reservas_De_Capitalizacion: number;
  otras_Reservas: number;
  acciones_Y_Participaciones_En_Patrimonio_Propias: number;
  resultados_De_Ejercicios_Anteriores: number;
  otras_Aportaciones_De_Socios: number;
  resultado_Del_Ejercicio: number;
  dividendo_A_Cuenta: number;
  ajustes_En_Patrimonio_Neto: number;
  subvenciones_Donaciones_Y_Legados_Recibidos: number;
  pasivo_No_Corriente: number;
  provisiones_A_Largo_Plazo: number;
  deudas_A_Largo_Plazo: number;
  deudas_Con_Entidades_De_Credito_B: number;
  acreedores_Por_Arrendamiento_Financiero_B: number;
  otras_Deudas_A_Largo_Plazo: number;
  deudas_Con_Empresas_Del_Grupo_Y_Asociadas_A_Largo_Plazo: number;
  pasivos_Por_Impuesto_Diferido: number;
  periodificaciones_A_Largo_Plazo: number;
  acreedores_Comerciales_No_Corrientes: number;
  deuda_Con_Caracteristicas_Especiales_A_Largo_Plazo: number;
  pasivo_Corriente: number;
  provisiones_A_Corto_Plazo: number;
  deudas_A_Corto_Plazo: number;
  deudas_Con_Entidades_De_Credito_C: number;
  acreedores_Por_Arrendamiento_Financiero_C: number;
  otras_Deudas_A_Corto_Plazo: number;
  deudas_Con_Empresas_Del_Grupo_Y_Asociadas_A_Corto_Plazo: number;
  acreedores_Comerciales_Y_Otras_Cuentas_A_Pagar: number;
  proveedores: number;
  proveedores_A_Largo_Plazo: number;
  proveedores_A_Corto_Plazo: number;
  otros_Acreedores: number;
  periodificaciones_A_Corto_Plazo: number;
  deuda_Con_Caracteristicas_Especiales_A_Corto_Plazo: number;
  total_Patrimonio_Neto_Y_Pasivo: number;

  constructor() {
  }

}
